import { render } from "./SidebarConfirmation.vue?vue&type=template&id=a62b5042&scoped=true&ts=true"
import script from "./SidebarConfirmation.vue?vue&type=script&lang=ts"
export * from "./SidebarConfirmation.vue?vue&type=script&lang=ts"

import "./SidebarConfirmation.vue?vue&type=style&index=0&id=a62b5042&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a62b5042"]])

export default __exports__